/**
 * Copyright (c) 2010-2022 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { AbstractControl, AsyncValidatorFn, ValidationErrors, Validator } from '@angular/forms';
import { ResetPasswordService } from '../../services/reset-password.service';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { ValidationError } from 'ajv';
import { Store } from '@ngxs/store';
import { UpdatePasswordComplexityUI } from '../../state/authState.actions';
import { PasswordRequirements } from '../../state/authState.model';

export class PasswordComplexityValidator {

    static createValidator(
        resetPasswordService: ResetPasswordService,
        store: Store,
        requirements: PasswordRequirements
    ): AsyncValidatorFn {
        return (control: AbstractControl): Observable<ValidationErrors> =>
            resetPasswordService.complexity$(control.value).pipe(
                tap(complexity => store.dispatch(new UpdatePasswordComplexityUI(complexity))),
                map((complexity) => {
                    return complexity.score >= requirements.minStrength ? null : { 'complexity': true };
                })
            );
    }
}
